import React from 'react'
import './HomeTitle.css'
function HomeTitle({ title }) {
    return (
        <div className="home_title_container mx-3">
<h3>            {title}
</h3>
        </div>
    )
}

export default HomeTitle
